import { DataProvider } from './DataProvider';
import memoGameA from './memoGameA';
import memoGameB from './memoGameB';

export default async function memoGameAB(quiz, context) {
    const a = await memoGameA(quiz, context);
    const b = await memoGameB(quiz, context);
    return new DataProvider([...a.items, ...b.items]);
}
